import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import PartnerForm from '../components/PartnerForm';
import { useDispatch, useSelector } from 'react-redux';
import { cancelPartnerCreate, editPartnerRequest, fetchPartnerById } from '../../api/partners/partnerSlice';

const PartnerEditPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, isPartnerEdited, selectedPartner } = useSelector((state) => state.partners);

  useEffect(() => {
    if (id) {
      dispatch(fetchPartnerById(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (isPartnerEdited) {
      navigate('/partners');
    }
  }, [isPartnerEdited, navigate]);

  const handleUpdate = async (data) => {
    dispatch(editPartnerRequest(data));
  };

  function handleCancel() {
    dispatch(cancelPartnerCreate());
    return navigate('/partners');
  }

  if (loading) {
    return null;
  }

  return (
    <Box elevation={3} sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>
        Edit Partner
      </Typography>
      <PartnerForm
        initialData={selectedPartner ?? {}}
        disabledFields={['email', 'password', 'is_embedded']}
        onSubmit={handleUpdate}
        onCancel={handleCancel}
        buttonText="Update"
      />
    </Box>
  );
};

export default PartnerEditPage;
